import { render, staticRenderFns } from "./change_photo.vue?vue&type=template&id=7d2e038c&"
import script from "./change_photo.vue?vue&type=script&lang=js&"
export * from "./change_photo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports